import { TABLE_CELL_MAX_LENGTH } from 'components/TableCell';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export function renderSafeHtml(html: string) {
  // Sanitize the HTML string
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  // Parse to React elements
  return parse(clean);
}

// Returns plain text with HTML tags stripped
export function stripHtmlTags(html: string): string {
  // Sanitize the HTML string
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  // Create a temporary DOM element to extract text content
  const temp = document.createElement('div');
  temp.innerHTML = clean;
  return temp.textContent || temp.innerText || '';
}

export function safeRenderItem(
  item: string,
  isExpanded: boolean,
  maxChars: number = TABLE_CELL_MAX_LENGTH
): React.ReactNode {
  return (
    <>
      {isExpanded ? (
        <div>{renderSafeHtml(item)}</div>
      ) : (
        <div>
          {item.length > maxChars
            ? `${renderSafeHtml(item.slice(0, maxChars))}...`
            : renderSafeHtml(item)}
        </div>
      )}
    </>
  );
}

export function safeRenderList(
  items: string[],
  isExpanded: boolean,
  itemsPerCell: number = 2
): React.ReactNode {
  return (
    <>
      {isExpanded
        ? items.map((s, i) => <div key={i}>{renderSafeHtml(s)}</div>)
        : items
            .slice(0, itemsPerCell)
            .map((s, i) => <div key={i}>{renderSafeHtml(s)}</div>)}
    </>
  );
}
